import { Stream } from 'models/Stream';
import Request from 'components/Request';
import Game from 'models/Game';

export const FEATURED_STREAMS_UPDATE = 'FEATURED_STREAMS_UPDATE';
export const RETRIEVE_EXTERNAL_STREAMS_BEGIN = 'RETRIEVE_EXTERNAL_STREAMS_BEGIN';
export const RETRIEVE_EXTERNAL_STREAMS_SUCCESS = 'RETRIEVE_EXTERNAL_STREAMS_SUCCESS';
export const RETRIEVE_EXTERNAL_STREAMS_FAIL = 'RETRIEVE_EXTERNAL_STREAMS_FAIL';


export const featuredStreamsUpdate = (streams) => {
	const streamList = [];
	_.each(streams, (stream) => {
		const convertedStream = Stream.create(stream);
		convertedStream.type = 'twitch';
		streamList.push(convertedStream);
	});
	return {
		type: FEATURED_STREAMS_UPDATE,
		payload: streamList
	};
};

export const retrieveExternalStreams = () => (dispatch, getState) => {
	const { fetchingExternalStreams } = getState().featuredStreams;
	if(fetchingExternalStreams) {
		return;
	}
	dispatch({
		type: RETRIEVE_EXTERNAL_STREAMS_BEGIN
	});
	var games = [
		{ game: 'Super Smash Bros. Brawl', logo: siteUrl + '/images/logos/game-filter-logos/project-plus-on.png' },
		{ game: 'Super Smash Bros. Melee', logo: siteUrl + '/images/logos/game-filter-logos/melee-on.png' },
		{ game: 'Super Smash Bros. for Wii U', logo: siteUrl + '/images/logos/game-filter-logos/smash-wii-u-on.png' },
		{ game: 'Super Smash Bros. Ultimate', logo: siteUrl + '/images/logos/game-filter-logos/smash-ultimate-on.png' },
		{
			game: 'Super Smash Bros. for Nintendo 3DS',
			logo: siteUrl + '/images/logos/game-filter-logos/smash-3ds-mini.png'
		}
	];

	var actions = [];

	const streamList = [];
	Request.apiv1Get('stream/smash_streams')
		.then((response) => {
			const streams = response.streams;
			if(!streams.length) {
				dispatch({
					type: RETRIEVE_EXTERNAL_STREAMS_FAIL,
				});
				return;
			}
			_.each(streams, (stream) => {
				const streamData = {};
				streamData.channel_name = stream.user_name;
				streamData.title = stream.title;
				streamData.id = stream.user_name;
				streamData.is_online = true;
				streamData.viewers = stream.viewer_count;
				streamData.gameData = Game.retrieve(stream.smashladder.game);
				streamData.type = 'twitch';
				streamData.preview_url = stream.thumbnail_url;

				const streamConverted = Stream.create(streamData);
				streamList.push(streamConverted);
			});
			dispatch({
				type: RETRIEVE_EXTERNAL_STREAMS_SUCCESS,
				payload: streamList
			});
		})
		.catch((error) => {
			Request.generalJsonError(error);
			dispatch({
				type: RETRIEVE_EXTERNAL_STREAMS_FAIL,
			});
		});
};